@if (!loading) {
  <main class="page-container sm">
    <h2>{{ 'login.sign_in' | transloco }}</h2>
    <p class="description">
      {{ 'login.description' | transloco }}
    </p>
    <form [formGroup]="form" (ngSubmit)="handleLoginClick()">
      <div class="mail-container">
        <input
          [ngClass]="{ error: form.controls.email.invalid && form.controls.email.touched }"
          formControlName="email"
          type="text"
          name="email"
          [placeholder]="'login.email' | transloco"
        />
        <button [disabled]="form.invalid && form.touched" class="btn secondary w-sm h-lg" type="submit">
          {{ 'login.log_in' | transloco }}
        </button>
      </div>
    </form>
    @if (respState === 'expiredCode') {
      <p class="info error mb-5">
        {{ 'login.expired_code' | transloco }}
      </p>
    }
  </main>
} @else {
  <div class="spinner-container p-absolute">
    <mat-spinner class="primary" [diameter]="30"></mat-spinner>
  </div>
}
